import type { AgentRequestState } from '../../types/negotiationAgents';

export function markStaleByOwner(
  entries: Record<string, Pick<AgentRequestState<unknown>, 'stale' | 'status' | 'requestId'>>,
  ownerKey: string,
): void {
  for (const [key, entry] of Object.entries(entries))
    if (key.includes(ownerKey)) {
      entry.stale = true;
      entry.status = 'idle';
      entry.requestId = undefined;
    }
}

export function agentQueryKey(query: object): string {
  return JSON.stringify(
    Object.entries<unknown>({ page: 1, limit: 12, ...query })
      .filter(([, value]) => value !== undefined && value !== '')
      .sort(([left], [right]) => (left < right ? -1 : left > right ? 1 : 0)),
  );
}

export const agentValidationKey = (
  query: string | import('../../types/negotiationAgents').AgentValidationQuery,
): string =>
  typeof query === 'string'
    ? query
    : (query.page ?? 1) === 1
      ? query.agentId
      : `${query.agentId}:validation:${query.page}`;

export const agentCatalogQueryKey = (query: object): string =>
  agentQueryKey(Object.fromEntries(Object.entries(query).filter(([key]) => key !== 'cursor')));

export const agentAvailabilityMutationKey = (agentId: string): string =>
  `agentAvailability:${agentId}`;
